"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRailzApiBalanceSheetSchema = exports.isRailzApiIncomeStatementSchema = exports.isRailzApiBusinessInfoSchema = exports.isRailzConnectSuccessAuthorizationDataSchema = void 0;
const Railz_1 = require("../types/Railz");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isRailzConnectSuccessAuthorizationDataSchema = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Railz_1.RailzConnect.SuccessAuthorizationDataSchema,
    typeguardName: 'isRailzConnectSuccessAuthorizationDataSchema',
});
exports.isRailzApiBusinessInfoSchema = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Railz_1.RailzApiReturnStructure.BusinessInfoSchema,
    typeguardName: 'isRailzApiBusinessInfoSchema',
});
exports.isRailzApiIncomeStatementSchema = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Railz_1.RailzApiReturnStructure.IncomeStatementSchema,
    typeguardName: 'isRailzApiIncomeStatementSchema',
});
exports.isRailzApiBalanceSheetSchema = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Railz_1.RailzApiReturnStructure.BalanceSheetSchema,
    typeguardName: 'isRailzApiBalanceSheetSchema',
});
//# sourceMappingURL=railz.js.map